import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { 
  Building2, 
  LayoutDashboard, 
  Users, 
  PlusCircle, 
  UserSquare2, 
  BarChart3, 
  Bell,
  Zap,
  MessageSquare,
  Smartphone,
  MapPin,
  Bot,
  FolderOpen,
  Mail
} from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { useNotifications } from '../../context/NotificationContext';
import { navConfig } from '../../config/navConfig';

const iconMap = {
  LayoutDashboard: LayoutDashboard,
  Users: Users,
  PlusCircle: PlusCircle,
  UserGroup: UserSquare2,
  BarChart3: BarChart3,
  Bell: Bell,
  Zap: Zap,
  MessageSquare: MessageSquare,
  Smartphone: Smartphone,
  MapPin: MapPin,
  Bot: Bot,
  FolderOpen: FolderOpen,
  MailIcon: Mail
};

const Sidebar = () => {
  const { user } = useAuth();
  const { unreadCount } = useNotifications();
  const navigate = useNavigate();
  const location = useLocation();

  if (!user) return null;

  const config = navConfig[user.role] || navConfig['telecaller'];

  return (
    <div className="sidebar" style={{
      width: '240px',
      minWidth: '240px',
      background: 'var(--color-background-primary)',
      borderRight: '1px solid var(--color-border-tertiary)',
      display: 'flex',
      flexDirection: 'column',
      height: '100vh'
    }}>
      <div className="sidebar-logo" style={{
        padding: '24px 20px',
        fontSize: '20px',
        fontWeight: 'bold',
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        color: 'var(--color-text-primary)'
      }}>
        <Building2 size={24} color="var(--color-brand-primary)" />
        <span>{process.env.REACT_APP_APP_NAME || 'CRM Automax'}</span>
      </div>

      <div className="nav-section" style={{ padding: '20px 0', flex: 1, overflowY: 'auto' }}>
        <div style={{
          fontSize: '11px',
          color: 'var(--color-text-tertiary)',
          padding: '0 20px 10px',
          textTransform: 'uppercase',
          letterSpacing: '0.05em'
        }}>
          {config.label} Menu
        </div>
        {config.nav.map((item) => {
          const Icon = iconMap[item.icon];
          const isActive = location.pathname === item.path;
          
          return (
            <div 
              key={item.id}
              onClick={() => navigate(item.path)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                padding: '12px 20px',
                cursor: 'pointer',
                fontSize: '14px',
                color: isActive ? 'var(--color-brand-primary)' : 'var(--color-text-secondary)',
                background: isActive ? 'var(--color-background-info)' : 'transparent',
                borderLeft: `3px solid ${isActive ? 'var(--color-brand-primary)' : 'transparent'}`,
                fontWeight: isActive ? '600' : '500',
                transition: 'all 0.2s ease'
              }}
              onMouseEnter={(e) => {
                if (!isActive) e.currentTarget.style.background = 'var(--color-background-secondary)';
              }}
              onMouseLeave={(e) => {
                if (!isActive) e.currentTarget.style.background = 'transparent';
              }}
            >
              {Icon && <Icon size={18} />}
              <span style={{ flex: 1 }}>{item.label}</span>
              {item.label === 'Notifications' && unreadCount > 0 && (
                <div style={{
                  background: '#E24B4A',
                  color: 'white',
                  borderRadius: '10px',
                  padding: '2px 8px',
                  fontSize: '10px',
                  fontWeight: 'bold'
                }}>
                  {unreadCount}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Sidebar;
